export default __webpack_public_path__ + "static/media/cart-arrow.d3ebea3a.svg";